<template>
  <form class="fees-form" @submit.prevent="formSubmit">
    <div class="form">
      <div class="form-field row mb-3">
        <div class="form-field mb-3 col-md-6">
          <label>Na akú dobu plánujete investovať (počet rokov)? <span class="text-highlighted"> *</span></label>
          <input placeholder="počet rokov" type="number" required="required" class="form-control" v-model="feesFormData.years" @keyup="recalculateYears">
        </div>
        <div class="form-field mb-3 col-md-6">
          <label>Akú mesačnú splátku by ste si chceli odkladať? <span class="text-highlighted"> *</span></label>
          <input placeholder="EUR" type="number" required="required" class="form-control" v-model="feesFormData.monthly" @keyup="recalculateMonthly">
        </div>
        <div class="form-field mb-3 col-md-12">
          <label>Aká je Vaša plánovaná celková investícia? <span class="text-highlighted"> *</span></label>
          <input placeholder="EUR" type="number" required="required" class="form-control" v-model="feesFormData.investment" @keyup="recalculateInvestment">
        </div>
      </div>
    </div>

    <label>Poplatok chcete uhradiť:</label>
    <div class="row mb-3">
      <b-form-radio-group
          v-model="feesFormData.payment"
          :required="true"
          buttons
          button-variant="outline-warning"
          class="col-12 w-100">
        <b-form-radio :value="1" class="w-50">
          priebežne z každej splátky
        </b-form-radio>
        <b-form-radio :value="2" class="w-50">
          v prvých splátkach
        </b-form-radio>
      </b-form-radio-group>
    </div>

    <FormGroup v-model="feesFormData" :fields="feesFormPaymentPercent" v-if="feesFormData.payment === 2"/>
  </form>
</template>

<script>
import FormGroup from "./form/FormGroup";

export default {
  name: "FeesForm",
  components: {
    FormGroup
  },
  data() {
    return {
      feesFormData: {
        years: 0,
        monthly: 0,
        investment: 0,
        payment: 1,
        percent: 0,
      },
      feesFormPaymentPercent: [
        {
          label: "V prvých splátkach chcem na poplatok zaplatiť:",
          type: "select",
          model: "percent",
          formWrapperClass: "col-md-12",
          required: true,
          options: [
            {
              label: "10% zo splátky",
              value: 10,
            },
            {
              label: "20% zo splátky",
              value: 20,
            },
            {
              label: "25% zo splátky",
              value: 25,
            },
            {
              label: "30% zo splátky",
              value: 30,
            },
            {
              label: "40% zo splátky",
              value: 40,
            },
            {
              label: "50% zo splátky",
              value: 50,
            },
          ],
        }
      ],
      sendData: null,
    };
  },
  watch: {
    feesFormData: {
      deep: true,
      handler() {
        if (this.sendData) {
          clearTimeout(this.sendData);
        }
        this.sendData = setTimeout(this.setFeesData, 300);
      },
    },
  },
  mounted() {
    this.getStoredData();
  },
  methods: {
    recalculateYears() {
      if (this.feesFormData.monthly > 0 && this.feesFormData.years > 0) {
        this.feesFormData.investment = this.feesFormData.monthly * (this.feesFormData.years * 12);
      }
    },
    recalculateMonthly() {
      if (this.feesFormData.monthly > 0 && this.feesFormData.years > 0) {
        this.feesFormData.investment = this.feesFormData.monthly * (this.feesFormData.years * 12);
      }
    },
    recalculateInvestment() {
      if (this.feesFormData.investment > 0 && this.feesFormData.years > 0) {
        this.feesFormData.monthly = Math.round(this.feesFormData.investment / (this.feesFormData.years * 12));
      }
    },
    setFeesData() {
      this.$store.commit('onboarding/setStrategyFeesData', this.feesFormData);
      this.$store.dispatch('onboarding/calculateFees');
    },
    getStoredData() {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const _that = this;
      this.$store.dispatch('onboarding/getFeesData').then((response) => {
        _that.feesFormData = response.data.result.investmentData;
        _that.$parent.setClientStrategy({id: response.data.result.strategyId});
      });
    }
  },
}
</script>

<style scoped lang="scss">
.fees-form {

}
</style>